export default __webpack_public_path__ + "static/media/3064.ad609f67.png";